import { render } from "./seldon_doc.vue?vue&type=template&id=dd09e22c"
import script from "./seldon_doc.vue?vue&type=script&lang=js"
export * from "./seldon_doc.vue?vue&type=script&lang=js"

import exportComponent from "/Users/romanmatveev/Documents/Dev/html_docs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__